import { useAddResourceToPatient } from '_api';
import { AddResourceToPatientPayload } from '_api/types';
import { SEVERITY } from '_constants/derived';
import { AlertMessage, BaseModal } from 'components/molecules';
import { AddResourceToPatientProfileForm } from 'components/organisms/forms/AddResourceToPatientProfileForm';
import React, { useState } from 'react';

import { AddToPatientProfileModalProps } from './types';

export const AddResourceToPatientProfileModal = ({
  open,
  onClose,
  patientId,
}: AddToPatientProfileModalProps) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { mutateAsync: addResourceToPatient } = useAddResourceToPatient();
  const [payload, setPayload] = useState<AddResourceToPatientPayload[]>([]);

  const close = () => {
    onClose();
    setPayload([]);
  };

  const updateList = async (ids: string[]) => {
    setPayload((current) => {
      let newPayload = [...current];
      ids.forEach((id) => {
        if (!newPayload.some((item) => item.contentId === Number(id))) {
          newPayload.push({
            contentId: Number(id),
            patientId: patientId,
          });
        }
      });

      newPayload = newPayload.filter((item) => ids.includes(item.contentId.toString()));

      return newPayload;
    });
  };

  const onSubmit = () => {
    const newPayload: AddResourceToPatientPayload[] = payload.filter((item) => item);
    newPayload.length > 0 &&
      addResourceToPatient(newPayload as AddResourceToPatientPayload[])
        .then(() => {
          setShowSuccess(true);
          setTimeout(() => close(), 1500);
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            setErrorMessage(
              'Unexpected error occured. Please close the modal and try again.',
            );
          } else if (error.message) {
            setErrorMessage(`ERROR: ${error.message}`);
          } else {
            setErrorMessage('Unexpected error. Please Try again.');
          }
        });
  };

  return (
    <BaseModal open={open} onClose={close} title={'Resource'}>
      <AddResourceToPatientProfileForm
        patientId={patientId}
        onSubmit={onSubmit}
        onBack={close}
        updateListOfObjects={updateList}
      />
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Successfully added resource to patient profile'}
      />
      <AlertMessage
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        severity={SEVERITY.error}
        message={
          'Failed to add resource to the patient profile. Resolve form issues and try again'
        }
      />
    </BaseModal>
  );
};
